import * as React from "react";
import {
	Avatar,
	Button,
	TextField,
	Box,
	Typography,
	Container,
	Grid,
	Alert,
	CircularProgress,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useTranslation } from "react-i18next";
import authService from "../services/auth-service";
import { useNavigate } from "react-router-dom";

export default function LogIn() {
	const { t } = useTranslation();
	const [err, setErr] = React.useState();
	const [loading, setLoading] = React.useState(false);
	const navigate = useNavigate();

	const handleSubmit = (event) => {
		event.preventDefault();
		setLoading(true);
		const data = new FormData(event.currentTarget);
		const email = data.get("email") || "";
		const password = data.get("password") || "";

		authService.login(email.toString(), password.toString()).then(
			(response) => {
				setLoading(false);
				navigate("/");
			},
			(error) => {
				setLoading(false);
				setErr(error.response?.statusText || "SOMETHING_WRONG");
			}
		);
	};

	return (
		<Container
			component="main"
			maxWidth="xs"
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				minHeight: "100vh",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					backgroundColor: "#fff",
					padding: 4,
					boxShadow: 3,
					borderRadius: 2,
					width: "100%", // Ensures full-width inside Container
					maxWidth: "400px",
					textAlign: "center",
				}}
			>
				{/* Avatar */}
				<Avatar
					sx={{
						m: 1,
						bgcolor: "secondary.main",
						width: 80,
						height: 80,
					}}
				>
					<LockOutlinedIcon sx={{ fontSize: 40 }} />
				</Avatar>

				{/* Title */}
				<Typography component="h1" variant="h5" fontWeight="bold" sx={{ mt: 2 }}>
					{t("AUTH.LOGIN")}
				</Typography>

				{/* Login Form */}
				<Box
					component="form"
					onSubmit={handleSubmit}
					noValidate
					sx={{ mt: 3, width: "100%" }}
				>
					<TextField
						margin="normal"
						required
						fullWidth
						id="email"
						label={t("AUTH.EMAIL")}
						name="email"
						autoComplete="email"
						variant="outlined"
						InputLabelProps={{ shrink: true }}
						autoFocus
					/>
					<TextField
						margin="normal"
						required
						fullWidth
						name="password"
						label={t("AUTH.PASSWORD")}
						type="password"
						id="password"
						autoComplete="current-password"
						variant="outlined"
						InputLabelProps={{ shrink: true }}
					/>

					{/* Error message */}
					{err && (
						<Alert severity="error" sx={{ mt: 2 }}>
							{t(`ERROR.${err}`)}
						</Alert>
					)}

					{/* Login Button */}
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						sx={{
							mt: 3,
							mb: 2,
							padding: "10px 0",
							backgroundColor: "#1976d2",
							fontWeight: "bold",
							"&:hover": {
								backgroundColor: "#115293",
							},
						}}
						disabled={loading}
					>
						{loading ? (
							<CircularProgress size={24} color="inherit" />
						) : (
							t("AUTH.LOGIN")
						)}
					</Button>
				</Box>
			</Box>
		</Container>
	);
}
